<template>
<div class="myinfo_wrap">
    <div class="page_title_center">
        P샵 구매내역      
    </div>   
    <div class="top_round_deco"></div>
    
    <div class="loading-spinner" v-if="!itemlists">
        <base-spinner></base-spinner>
    </div>
    <div v-else>       
        <div class="list_wrap" v-if="itemlists">
            <div v-for="(item, index) in itembuylists.data" :key="index" class="item_block" :class="{'isUseable':item.remain>0}">     
                <div class="left_part">
                    <div class="thumb">
                        <div :style="{backgroundImage:`url(/storage/${item.goods.image})`}" @click="linkgoods(item.goods.id)">           
                            <!-- <img :src="`/storage/${item.image}`"> -->
                        </div>   
                    </div>
                    <div class="goods_info">
                        <div class="item_name">
                            {{item.goods_title}}
                        </div>
                        <div class="price">
                            <template v-if="item.goods_price > 0">
                                {{addComma(item.goods_price)+' 원'}}
                            </template>
                            <template v-else>
                                {{addComma(Math.abs(item.goods_point))+' P'}}
                            </template>
                        </div>
                        <div class="time_count">
                            <span><display-time :time="item.created_at"/></span>
                            <span>구매 [{{item.count}}]</span>                                     
                        </div>
                    </div>     

                </div>               
                <div class="right_part">
                  
                    <div class="btn_part">
                        <div class="btn_use" v-if="ckday() && item.state===1 ">
                            <base-button-sm mode="orange" @click="refund(item.id)">환불신청</base-button-sm>
                        </div>
                        <span v-else>
                            {{itemState[item.state]}}
                        </span>                                          
                    </div>
                </div>            
            </div>   
          
        </div>
        <div class="paginate" ><paginate store="goods" collection="goodsBuy"  @paging="getBuyItems" :isMobile="true"/></div>
    </div>
</div>
  <!-- 환불신청 -->
        <base-dialog :show="popdialog" title="환불신청" @close="popClose()" apply="환불신청" @apply="confirmRefund()" :isMobile="true">
            <div class="dialog_box">
                <div class="item_title">
                <h1>[{{refundGoods.goods_title}} ] 상품구매 취소</h1>  
                <span>상품구매 취소는 월요일 ~ 목요일 까지만 가능합니다.</span>           
                </div>
                <div class="input_area">   
                    
                    <div class="description danger">
                        해당상품의 구매취소 요청 하시겠습니까?                              
                    </div>               
                </div>               
            </div>
        </base-dialog>
</template>
<script>
import { myGoodsBuy } from '@/components/mixins/pages/myGoodsBuy.js'
export default {
    name:'mobile_GoodsBuy',
    props:[
        
    ],
    data(){
        return{

        }
    },
    mixins:[
        myGoodsBuy
    ],
    components:{
        
    },
    mounted() {
    },
    methods:{
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/mobile';
.list_wrap{
    padding: 10px 20px 0;
    .item_block{
        display: flex;
        justify-content: space-between;
        border-bottom:1px solid #f2f2f2;
        padding:10px 0;
        .left_part{    
            display: flex;
            .thumb{
                div{
                    width:50px;
                    height:50px;
                    background-position: center;
                    background-size:cover; 
                    border-radius:10px;
                }
            }   
            .goods_info{
                margin-left:10px;
                .item_name{           
                    overflow: hidden;         
                    line-height: 19px;           
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 14px;
                    font-weight: 700;
                    margin-bottom: 3px; 
                }
                .price{
                    display: inline-block;    
                }
                .time_count{
                    display: flex;
                    margin-top:3px;
                    span{
                        display: inline-block;
                        padding-right: 5px;
                    }
                    .remain{
                        background: #0d4e7c; 
                        border-radius: 5px;  
                        color:#b3d9ed;
                        padding:0 5px;
                    }
                }
            }   
          
        }
        .center_part{
            .remain{
                border: 1px solid #d8d8d8;
                border-radius: 5px;
                text-align: center;
                .remain_header{
                    padding:2px 5px;
                    background: #0d4e7c;
                    color:#b3d9ed;
                }
                .remain_count{
                    font-weight: bold;
                    font-size: 16px;
                    line-height: 30px;
                }
            }
        }
        .right_part{
            display: flex;
           
            .btn_part{
                display: flex;
                align-items: center;
                .btn_use{
                    height: 80%;
                    margin:0 2px;
                }
            }
        }
    }
}
.paginate{
    margin-top:20px;
}
</style>